import { section } from 'framer-motion/client';
import React, { useState } from 'react';
import { PaperBG, PaperDarkBG } from '../kits';

const SetCards = () => {
  const [visibleTextIndex, setVisibleTextIndex] = useState(null);

  const handleToggleText = (index) => {
    setVisibleTextIndex(visibleTextIndex === index ? null : index);
  };

  const setcards = [
    {
      title: "STEP 01",
      description: [
        "Ein Problem mit der Umsetzung von Tools in 2D, 3D oder Programmierung",
        "Du würdest gern mehr Dinge vereinfachen?",
        "Dein Wissen ist nicht auf dem neusten Stand?",
        "SocialMedia mit Adobe besser verstehen?"
      ],
      additionalText: "Problem kennen.",
    },
    {
      title: "STEP 02",
      description: [
        "Suche in der Suchleiste",
        "gib zum Beispiel SocialMedia ein",
        "Gibt es nicht genau das  was du suchst, schreib uns einfach.",
        "Wir stellen Dir dann einen individuellen für dein Problem zusammen"
      ],
      additionalText: "Kurs filtern",
    },
    {
      title: "STEP 03",
      description: [
        "Überblick über Schritt 03",
        "Verstehen Sie komplexe Konzepte",
        "Erstellen Sie Projekte und zeigen Sie Ihre Fähigkeiten."
      ],
      additionalText: "Anmelden",
    },
    {
      title: "STEP 04",
      description: [
        "Abschluss von Setcard 04",
        "Überblick der wichtigsten Konzepte",
        "Erstellen Sie Ihr eigenes Portfolio und präsentieren Sie es."
      ],
      additionalText: "Kurstermin.",
    },
  ];

  return (
    <PaperBG>
    <section className=''>
    <div className="container mx-auto px-6 py-12 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6">
      {setcards.map((setcard, index) => (
        <div 
          key={index} 
          className="bg-gray-800 text-white rounded-xl shadow-xl p-6 flex flex-col h-96 relative group overflow-hidden cursor-pointer"
          onMouseEnter={() => handleToggleText(index)}
          onMouseLeave={() => handleToggleText(index)}
        >
          {/* Inhalt der Setcard */}
          <div className="flex items-center space-x-4">
            <div className="text-6xl font-bold text-orange-300">
              {setcard.title.split(" ")[1]} {/* Zahl extrahieren */}
            </div>
            <div className="text-left">
              <p className="text-lg">{setcard.additionalText}</p>
            </div>
          </div>

          {/* Großer pinker Pfeil, der zur nächsten Setcard zeigt */}
          {index < setcards.length - 1 && (
            <div className="   absolute bottom-4 left-[-10] text-orange-300 text-6xl transform transition-transform duration-300 group-hover:translate-x-2 sm:group-hover:translate-y-2 ">
              &rarr; {/* Pfeilsymbol */}
            </div>
          )}

          {/* Overlay beim Hover */}
          <div    
  className={`${
    visibleTextIndex === index ? "translate-y-0 opacity-100" : "translate-y-full opacity-0"
  } absolute inset-0 bg-gray-900 text-white p-6 transition-transform duration-500 ease-in-out rounded-xl shadow-xl flex flex-col justify-center`}
  style={{
    zIndex: 10,
    pointerEvents: visibleTextIndex === index ? 'auto' : 'none',
  }}
>
  <div className="text-left">
    <ul className="list-disc pl-5 space-y-2 text-sm"> {/* Liste mit Aufzählungspunkten */}
      {setcard.description.map((desc, i) => (
        <li key={i}>{desc}</li> 
      ))}
    </ul>
  </div>
  <div className="   absolute bottom-6 right-5 text-orange-300 text-6xl transform transition-transform duration-300 group-hover:translate-x-2 sm:group-hover:translate-y-2 ">
              &rarr; {/* Pfeilsymbol */}
            </div>
        </div>






        </div>
      ))}
    </div>
    </section>
    </PaperBG>
  );
}

export default SetCards;